<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="审批结果" prop="isPass">
        <RadioGroup v-model="form.isPass">
          <Radio label="通过"></Radio>
          <Radio label="不通过"></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="审批原由" prop="remark" v-show="form.isPass === '不通过'">
        <Input v-model="form.remark" :maxlength="100" type="textarea" :rows="4"></Input>
      </FormItem>
      <FormItem>
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </FormItem>
    </Form>
    <!-- <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div> -->
  </sl-side-panel>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      rules: {
        isPass: [{ required: true, message: '请选择审批结果', trigger: 'blur,change' }],
      },
      id: null,
      modalVisible: false,
      loading: false,
      // itemTitle必须有值，当第一次点击数据为空时，就不会显示头和关闭，一定要有默认值
      itemTitle: '审批',
      form: {},
    }
  },

  created() {},

  computed: {},
  watch: {},

  methods: {

    init(id) {
      this.itemTitle = '审批'
      this.show()
      this.id = id
      this.form = {}
    },
    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          // this.$Message.error('参数错误');
        }
      })
    },
    save() {
      let params = {
        id: this.id,
        isPass: this.form.isPass === '通过' ? 1 : 0
      }
      if (this.form.isPass === '不通过') {
        if (!this.form.remark) {
          this.$Message.error('请输入不通过原由')
          return
        }
        params.remark = this.form.remark
      }
      this.loading = true
      this.$request.informationReview(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.hide()
        }
        this.loading = false
      })

    },
  }
}

</script>
<style scoped lang="less">
.imgs {
  width: 100px;
  display: inline-block;
  padding: 10px;
  cursor: pointer;
  vertical-align: top;
}

</style>
